import React, { useId } from 'react';
import './BlueXLoader.css';

/** One branded wait mark for empty authenticated content. */
export default function BlueXLoader({ label = 'Loading', size = 'medium', className = '' }) {
  const rawId = useId().replace(/:/g, '');
  const sheenId = `blue-x-sheen-${rawId}`;
  const glowId = `blue-x-glow-${rawId}`;

  return (
    <div
      className={`blue-x-loader blue-x-loader--${size} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="blue-x-loader-stage" aria-hidden="true">
        <svg className="blue-x-loader-svg" viewBox="0 0 64 64" focusable="false">
          <defs>
            <linearGradient id={sheenId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop className="blue-x-sheen-stop blue-x-sheen-stop--a" offset="0%" stopColor="#4eb4e6" />
              <stop className="blue-x-sheen-stop blue-x-sheen-stop--b" offset="42%" stopColor="#0077b8" />
              <stop className="blue-x-sheen-stop blue-x-sheen-stop--c" offset="100%" stopColor="#064e86" />
            </linearGradient>
            <filter id={glowId} x="-40%" y="-40%" width="180%" height="180%">
              <feGaussianBlur in="SourceGraphic" stdDeviation="0.7" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g className="blue-x-loader-mark" filter={`url(#${glowId})`}>
            <path className="blue-x-arm blue-x-arm--a" d="M10 10 L54 54" stroke={`url(#${sheenId})`} />
            <path className="blue-x-arm blue-x-arm--b" d="M54 10 L10 54" stroke={`url(#${sheenId})`} />
          </g>
        </svg>
      </span>
      {label ? <span className="blue-x-loader-label risks-page-loading-text">{label}</span> : null}
    </div>
  );
}

/** Full-page wait used before a screen is allowed to render. */
export function PageDataLoader({ label = 'Loading' }) {
  return (
    <div className="dashboard-data-loader dashboard-data-loader--initial">
      <BlueXLoader size="large" label={label} />
    </div>
  );
}
